// URL <-> selection state. Source of truth for shareable URL is window.location.search.
const VALID_CODE = /^[A-Z]{3}$/;

export function parseTeamsFromUrl(search: string): string[] {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const raw = params.get('teams') ?? '';
  const seen = new Set<string>();
  const out: string[] = [];
  for (const tok of raw.split(',')) {
    const upper = tok.trim().toUpperCase();
    if (!VALID_CODE.test(upper)) continue;
    if (seen.has(upper)) continue;
    seen.add(upper);
    out.push(upper);
  }
  return out;
}

export function writeTeamsToUrl(codes: readonly string[]): void {
  const base = window.location.pathname;
  if (codes.length === 0) {
    window.history.replaceState({}, '', base);
  } else {
    const teamsStr = codes.map((c) => c.toLowerCase()).join(',');
    window.history.replaceState({}, '', base + '?teams=' + teamsStr);
  }
}

export class Selection {
  private set: Set<string>;
  private listeners = new Set<(codes: string[]) => void>();
  constructor(initial: readonly string[] = []) {
    this.set = new Set(initial.map((c) => c.toUpperCase()));
  }
  toggle(code: string): boolean {
    const upper = code.toUpperCase();
    const added = !this.set.has(upper);
    if (added) this.set.add(upper); else this.set.delete(upper);
    this.notify();
    return added;
  }
  setAll(codes: readonly string[]): void {
    this.set = new Set(codes.map((c) => c.toUpperCase()));
    this.notify();
  }
  clear(): void {
    this.set.clear();
    this.notify();
  }
  has(code: string): boolean { return this.set.has(code.toUpperCase()); }
  size(): number { return this.set.size; }
  codes(): string[] { return [...this.set].sort(); }
  subscribe(listener: (codes: string[]) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
  private notify(): void {
    const snapshot = this.codes();
    for (const l of this.listeners) l(snapshot);
  }
}
